<template>
  <div class="w-full flex justify-content-center align-items-center mb-1" :style="{ height: containerHeight }">
    <img
      v-if="src && !fallo"
      :src="src"
      :alt="alt"
      class="w-full h-full object-contain zapi-image-transition drop-shadow-md"
      @error="fallo = true"
    />
    <div v-else class="flex align-items-center justify-content-center w-full h-full bg-gray-100 border-round-xl">
      <i class="pi pi-image text-4xl text-300"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZapiProductImage',
  props: {
    src: { type: String, required: true },
    alt: { type: String, default: 'Producto' },
    containerHeight: { type: String, default: '130px' }
  },
  data() {
    // Etapa 3A: si la imagen no carga (404, sin conexión) se muestra la imagen de reemplazo
    return { fallo: false };
  },
  watch: {
    src() {
      this.fallo = false;
    }
  }
}
</script>
<style scoped>
.zapi-image-transition {  
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);  
}
</style>